import clsx from 'clsx'

import BackdropBase from '~/ui/BackdropBase/BackdropBase'

interface SliderResponsiveProps {
  onClose: () => void
  children: React.ReactNode
}

export const SliderResponsive = ({ onClose, children }: SliderResponsiveProps) => {
  return (
    <BackdropBase isOpen={true} onClose={onClose}>
      <div
        className={clsx(
          'absolute bg-white shadow-lg overflow-y-auto',
          'top-auto sm:top-0 right-0 bottom-0 left-0 sm:left-auto',
          'h-auto max-h-[90vh] sm:max-h-none sm:h-full w-full sm:w-[400px] rounded-t-3xl sm:rounded-none',
        )}
      >
        {children}
      </div>
    </BackdropBase>
  )
}
